import { useQuery } from '@tanstack/react-query';
import { serviceVendorsClient } from '@/services/petseo.service';
import type { ServiceVendorId, EmployeeId } from '@/services/api/petseo.client.wrapper';
import { employeeCalendarKeys } from '@petseo/shared';

export const useEmployeeCalendarStatus = (serviceVendorId: ServiceVendorId, employeeId: EmployeeId) => {
  return useQuery({
    queryKey: employeeCalendarKeys.forEmployee(serviceVendorId, employeeId),
    queryFn: async () => {
      const response = await serviceVendorsClient.getEmployeeCalendarStatusEndpoint(serviceVendorId, employeeId);
      return response.data;
    },
    enabled: !!serviceVendorId && !!employeeId,
  });
};
